"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.SliderControl = exports.Slider = void 0;
var _slider = _interopRequireDefault(require("./slider"));
exports.Slider = _slider["default"];
var _sliderControl = _interopRequireDefault(require("./slider-control"));
exports.SliderControl = _sliderControl["default"];